import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { IPatientAppointmentModel } from "@/Patient/Models/UI/Appointment/IPatientAppointmentModel";

import styles from "./AppointmentFilters.module.scss";

interface AppointmentFitlersProps {
    model: IPatientAppointmentModel;
    asapClick: () => void;
    shouldIgnorePublishingRules: boolean;
}

function AppointmentFilters(props: AppointmentFitlersProps): JSX.Element {
    const { getText } = useTranslation();

    const renderHeaderItem = (
        onClick: () => void,
        label: string,
        isChecked: boolean = false,
        sectionEnd: boolean = false
    ): JSX.Element => (
        <li className={sectionEnd ? styles.endPipe : ""}>
            <a
                onClick={() => onClick()}
                className={isChecked ? "underline" : ""}
            >
                {label}
            </a>
        </li>
    );

    return (
        <div className="tbc c1">
            <ul className="weekdays clearfix">
                {renderHeaderItem(
                    () => sessionStore.dispatch(LocalPatientOperations.Appointment.MondayClick),
                    getText("DayMonLabel"),
                    props.model.get("MondayCheck")
                )}
                {renderHeaderItem(
                    () => sessionStore.dispatch(LocalPatientOperations.Appointment.TuesdayClick),
                    getText("DayTueLabel"),
                    props.model.get("TuesdayCheck")
                )}
                {renderHeaderItem(
                    () => sessionStore.dispatch(LocalPatientOperations.Appointment.WednesdayClick),
                    getText("DayWedLabel"),
                    props.model.get("WednesdayCheck")
                )}
                {renderHeaderItem(
                    () => sessionStore.dispatch(LocalPatientOperations.Appointment.ThursdayClick),
                    getText("DayThuLabel"),
                    props.model.get("ThursdayCheck")
                )}
                {renderHeaderItem(
                    () => sessionStore.dispatch(LocalPatientOperations.Appointment.FridayClick),
                    getText("DayFriLabel"),
                    props.model.get("FridayCheck"),
                    true
                )}
                {renderHeaderItem(
                    () => sessionStore.dispatch(LocalPatientOperations.Appointment.WeekdayClick),
                    getText("WeekdaysLabel"),
                    props.model.get("WeekdayCheck")
                )}
                {renderHeaderItem(
                    () => sessionStore.dispatch(LocalPatientOperations.Appointment.WeekendClick),
                    getText("WeekendLabel"),
                    props.model.get("WeekendCheck"),
                    true
                )}
                {renderHeaderItem(
                    () => sessionStore.dispatch(LocalPatientOperations.Appointment.AMClick),
                    "AM",
                    props.model.get("AMCheck")
                )}
                {renderHeaderItem(
                    () => sessionStore.dispatch(LocalPatientOperations.Appointment.PMClick),
                    "PM",
                    props.model.get("PMCheck"),
                    true
                )}
                {renderHeaderItem(
                    () => sessionStore.dispatch(LocalPatientOperations.Appointment.AddWeekClick, { value: 1 }),
                    "1W"
                )}
                {renderHeaderItem(
                    () => sessionStore.dispatch(LocalPatientOperations.Appointment.AddWeekClick, { value: 2 }),
                    "2W"
                )}
                {renderHeaderItem(
                    () => sessionStore.dispatch(LocalPatientOperations.Appointment.AddWeekClick, { value: 3 }),
                    "3W"
                )}
                {renderHeaderItem(
                    () => sessionStore.dispatch(LocalPatientOperations.Appointment.AddMonthClick, { value: 1 }),
                    "+1Mo",
                    false,
                    true
                )}
                {renderHeaderItem(
                    () => this.props.asapClick(),
                    "ASAP"
                )}
                {renderHeaderItem(
                    () => sessionStore.dispatch(LocalPatientOperations.Appointment.IgnorePublishingRulesClick),
                    getText("IgnorePublicationRestrictionsLabel"),
                    props.shouldIgnorePublishingRules
                )}
            </ul>
        </div>

    );
}

export { AppointmentFilters };
